const steps = {
  presign: ['CheckIn', 'Photo', 'Agreement'],
  'check-in': ['CheckIn', 'Photo', 'Agreement', 'HostLookup'],
};

export const getSteps = (registrationType) => steps[registrationType];

export const getStepWidth = (registrationType) => 100 / getSteps(registrationType).length - 2;
